const stripQueryKey = (fullKey, listNameKey, paginationKey) => {
  if (paginationKey === fullKey) return fullKey;
  return fullKey.substring(listNameKey.length + 1, fullKey.length - 1);
};
export default stripQueryKey;
//# sourceMappingURL=strip-query-key.js.map